import { SiteHeader } from '../components/SiteHeader';
import { SiteFooter } from '../components/SiteFooter';

export default function NotFound() {
  return <div className="landing-page"><SiteHeader /><main className="mx-auto max-w-6xl px-6 py-40"><h1 data-testid="not-found-heading" className="mb-6 text-4xl font-bold">Page not found</h1><a data-testid="not-found-home-link" href="/" className="text-[#7c4a97] underline">GenMoney</a></main><SiteFooter /></div>;
}